import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringToNumber'
})
export class StringToNumberPipe implements PipeTransform {
  transform(value: string): number {
    // Use parseFloat or Number to parse the string to a number
    return parseFloat(value);
  }
}
